import React, { FC } from "react";
import { useFetchBitcoinPrice } from "../../hooks/query/useFetchBitcoinPrice";

interface DataTableProps {}

export const DataTable: FC<DataTableProps> = () => {
  const { data: bitcoin } = useFetchBitcoinPrice("BTC");
  return (
    <div className="data-table">
      <table>
        <thead>
          <tr style={{ height: "56px" }}>
            <th>Asset</th>
            <th>Market Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span>Bitcoin</span>
            </td>
            <td>{bitcoin?.rate?.toFixed(2)} USD </td>
          </tr>
          <tr>
            <td>
              <span>USDT</span>
            </td>
            <td>1.00 USD</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export const getRate = (
  rate: any,
  asset: "bitcoin",
  currency: "NGN" | "GHS",
  type: "buy" | "sell"
): string => {
  return rate
    ? rate[asset][type][currency]
      ? rate[asset][type][currency]
      : "N/A"
    : "N/A";
};
